import React from 'react';
import { convertAmount, getAmountWithCurrency } from '@pascal/pascal-core';
import { toFixed } from '../../../helpers/arithmeticOperations';
import { globalTranslationKeys } from '../../../enums';

export const YouWinPopUp = ({ t, amount = 1000 }) => {
  return (
    <div className='odd-you-win-content'>
      <span className='odd-you-win-coef-bl'>
        <span className='odd-you-win-coef-txt'>{t(globalTranslationKeys.YouWin)}</span>
      </span>
      <p className='odd-you-win-amount'>
        {getAmountWithCurrency({ amount: convertAmount(toFixed(Number(amount), 2)) })}
      </p>
    </div>
  );
};
